import axios from "axios";
import baseURL from "../../Config";
export async function inspectionRequest(path = "", data, method) {
  const stored = JSON.parse(
    localStorage.getItem("adminUser") ||
      localStorage.getItem("userDetails") ||
      "{}"
  );
  const token = stored?.data?.token || stored?.data?.accessToken;
  const response = await axios({
    method: method || (data ? "POST" : "GET"),
    url: `${baseURL}machineInspection${path}`,
    data,
    headers: { authorization: `Bearer ${token}` },
  });
  return response.data.data;
}
export const errorMessage = (error) =>
  error?.response?.data?.message ||
  "No se pudo completar la operación. Comprueba tu conexión e inténtalo de nuevo.";
export const newRequestId = () => {
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64;
  bytes[8] = (bytes[8] & 63) | 128;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(
    12,
    16
  )}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
